import EdoActivity from './EdoActivity';

export default EdoActivity;
